import { Modal, ModalContent, ModalTrigger } from 'src/shared/ui/components/Modal';

import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';
import { confetti } from '@shared/utils/helpers';

import { HandOutParkingStickerButtonForm } from './HandOutParkingStickerButtonForm';

type ParkingRequestParkingSticker = App.Domain.Parking.Data.ParkingRequestParkingStickerData;

type HandOutParkingStickerButtonProps = {
  parkingRequestParkingSticker: ParkingRequestParkingSticker;
  onHandOut?: (parkingRequestParkingSticker: ParkingRequestParkingSticker) => void;
};

export function HandOutParkingStickerButton({
  parkingRequestParkingSticker,
  onHandOut,
}: HandOutParkingStickerButtonProps) {
  if (parkingRequestParkingSticker.claimedAt) {
    return null;
  }

  return (
    <Modal>
      <ModalTrigger asChild>
        <Button size="sm" disabled={!!parkingRequestParkingSticker.claimedAt}>
          <Icon icon="hand-out" /> Hand Out
        </Button>
      </ModalTrigger>
      <ModalContent title="Hand Out Parking Sticker">
        {({ close }) => (
          <HandOutParkingStickerButtonForm
            parkingRequestParkingSticker={parkingRequestParkingSticker}
            onSave={(parkingSticker: ParkingRequestParkingSticker) => {
              onHandOut?.(parkingSticker);
              confetti(true);
              close();
            }}
            onCancel={close}
          />
        )}
      </ModalContent>
    </Modal>
  );
}
